:host {
  position: relative;
  display: inline-block;
}

.spw-tooltip {
  &__container {
    display: inline-block;
    cursor: pointer;
    &:hover {
      .spw-tooltip__content {
        opacity: 1;
        visibility: visible;
      }
    }
  }

  &__title {
    display: block;
    margin-bottom: 4px;
    color: var(--spw-colors-support-grey-grey-100);
  }

  &__content {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    background-color: var(--spw-colors-support-grey-grey-900);
    color: var(--spw-colors-support-grey-grey-400);
    padding: 12px;
    border-radius: 8px;
    font-size: 14px;
    white-space: nowrap;
    z-index: 10;
    opacity: 0;
    visibility: hidden;

    &:after {
      content: '';
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      border-width: 3px;
      border-style: solid;
      border-color: var(--spw-colors-support-grey-grey-900) transparent transparent transparent;
    }

    &--top {
      bottom: 100%;
      margin-bottom: 5px;
      &:after {
        top: 100%;
      }
    }

    &--bottom {
      top: 100%;
      margin-top: 5px;
      &:after {
        bottom: 100%;
        border-color: transparent transparent var(--spw-colors-support-grey-grey-900) transparent;
      }
    }

    &--left {
      top: 50%;
      left: auto;
      right: 100%;
      transform: translateY(-50%);
      margin-right: 5px;

      &:after {
        top: 50%;
        left: 100%;
        transform: translateY(-50%);
        border-color: transparent transparent transparent var(--spw-colors-support-grey-grey-900);
      }
    }

    &--right {
      top: 50%;
      left: 100%;
      transform: translateY(-50%);
      margin-left: 5px;

      &:after {
        top: 50%;
        left: auto;
        right: 100%;
        transform: translateY(-50%);
        border-color: transparent var(--spw-colors-support-grey-grey-900) transparent transparent;
      }
    }
  }
}
